import { defineComponent as y, ref as i, resolveComponent as b, createBlock as g, openBlock as $, normalizeClass as p, createSlots as v, withCtx as l, withDirectives as c, createElementVNode as k, vModelDynamic as S, createTextVNode as C, toDisplayString as D, renderSlot as n } from "vue";
import { E as u, D as V } from "./DFormField-Bgedq8hs.js";
import "./clone-CVUr0Shx.js";
import { u as B } from "./useModel-8eDFJuHe.js";
import "./cloneDeep-BYiA6ooS.js";
import { n as F } from "./index.browser-CWCjzKuA.js";
import { _ as z } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import './assets/DInput-DAwYGIl0.css';const h = y({
  compatConfig: {
    MODE: 3
  },
  components: {
    DFormField: V
  },
  props: {
    clearable: Boolean,
    blocked: Boolean,
    disabled: Boolean,
    dark: Boolean,
    error: Boolean,
    size: { type: String, default: () => u.LARGE },
    loading: Boolean,
    modelValue: { type: String, default: void 0 },
    label: { type: String, default: "" },
    placeholder: { type: String, default: void 0 },
    name: { type: String, default: "" },
    type: { type: String, default: "text" },
    autocomplete: { type: String, default: void 0 },
    inputmode: { type: String, default: "text" },
    id: { type: String, default: () => F() }
  },
  emits: {
    "update:modelValue": (e) => e === void 0 || typeof e == "string"
  },
  setup(e, { emit: o }) {
    const t = i(!1), d = B(e, "modelValue", o), s = i(null);
    return {
      localValue: d,
      focused: t,
      ESize: u,
      onClear: () => {
        var a;
        d.value = void 0, (a = s.value) == null || a.focus();
      },
      input: s
    };
  }
}), E = {
  "d-input__input": "_d-input__input_18wap_7"
}, M = ["id", "disabled", "readonly", "type", "placeholder", "name", "autocomplete", "inputmode"];
function A(e, o, t, d, s, m) {
  const a = b("DFormField");
  return $(), g(a, {
    id: e.id,
    class: p(e.$style["d-input"]),
    focused: e.focused,
    disabled: e.disabled,
    error: e.error,
    dark: e.dark,
    size: e.size,
    blocked: e.blocked,
    "has-value": !!e.localValue || !!e.placeholder && e.focused,
    loading: e.loading,
    clearable: e.clearable,
    onClear: e.onClear
  }, v({
    label: l(() => [
      C(D(e.label), 1)
    ]),
    control: l(({ id: f }) => [
      c(k("input", {
        id: f,
        ref: "input",
        "onUpdate:modelValue": o[0] || (o[0] = (r) => e.localValue = r),
        class: p(e.$style["d-input__input"]),
        disabled: e.disabled,
        readonly: e.blocked,
        type: e.type,
        placeholder: e.focused ? e.placeholder : "",
        name: e.name,
        autocomplete: e.autocomplete,
        inputmode: e.inputmode,
        onFocus: o[1] || (o[1] = (r) => e.focused = !0),
        onBlur: o[2] || (o[2] = (r) => e.focused = !1)
      }, null, 42, M), [
        [S, e.localValue]
      ])
    ]),
    _: 2
  }, [
    e.$slots.innerPrepend ? {
      name: "innerPrepend",
      fn: l(() => [
        n(e.$slots, "innerPrepend")
      ]),
      key: "0"
    } : void 0,
    e.$slots.innerAppend ? {
      name: "innerAppend",
      fn: l(() => [
        n(e.$slots, "innerAppend")
      ]),
      key: "1"
    } : void 0,
    e.$slots.messages ? {
      name: "messages",
      fn: l(() => [
        n(e.$slots, "messages")
      ]),
      key: "2"
    } : void 0,
    e.$slots.prepend ? {
      name: "prepend",
      fn: l(() => [
        n(e.$slots, "prepend")
      ]),
      key: "3"
    } : void 0,
    e.$slots.append ? {
      name: "append",
      fn: l(() => [
        n(e.$slots, "append")
      ]),
      key: "4"
    } : void 0
  ]), 1032, ["id", "class", "focused", "disabled", "error", "dark", "size", "blocked", "has-value", "loading", "clearable", "onClear"]);
}
const w = {
  $style: E
}, T = /* @__PURE__ */ z(h, [["render", A], ["__cssModules", w]]);
export {
  T as D
};
